// extracted by mini-css-extract-plugin
export default {"root":"style_root__54xYT","placeholderContainer":"style_placeholderContainer__EmGY1"};